export default __webpack_public_path__ + "static/media/github.c66b3c5a.svg";